<template>
    <Modal v-model="contactMdl" width="420" class-name="vertical-center-modal no-padding">
        <div class="close-btn" slot="close">
            <i class="iconfont icon-pop-close"></i>
        </div>
        <div class="contact-cont">
            <div class="imgCon">
                <img src="../../images/egg/deduction.png" alt="">
            </div>
            <p v-if="type === 'offer'" class="Text">本次报价将扣除<span>{{eggNum}}</span>个恐龙蛋</p>
            <p v-if="type === 'download'" class="Text">本次下载将扣除<span>{{eggNum}}</span>个恐龙蛋</p>
            <p v-if="type === 'exchange'" class="Text">本次兑换将扣除<span>{{eggNum}}</span>个恐龙蛋</p>
            <div class="button">
                <span @click="cancel">取消</span>
                <span @click="sured">确定</span>
            </div>
        </div>
    </Modal>
</template>
<script>
    export default{
        data(){
            return {
                contactMdl:false,
                type: '',
                eggNum: 0
            }
        },
        methods:{
            open(type, eggNum){
                this.eggNum = eggNum
                this.type = type
                this.contactMdl = true;
            },
            cancel() {
                this.contactMdl = false;
            },
            sured() {
               this.$emit('offerSubmit');
            }
        }
    }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .contact-cont{
        height: 360px;
        >.imgCon{
            display: inline-block;
            text-align: center;
            >img{
                margin-top: 46px;
            }
        }
        i{
            font-size:44px;
            color:#308697;
        }
        .Text{
            font-size: 20px;
            color: #353838;
            letter-spacing: 0;
            text-align:center;
            >span{
                font-size: 20px;
                color:#E14B5D;
            }
        }
        .time{
            font-size: 14px;
            color: #308697;
            letter-spacing: 0;
            text-align:center;
            margin-top:9px;
        }
        .button{
            margin-top: 64px;
            width: 100%;
            height: 40px;
            text-align: center;
            >span{
                display: inline-block;
                width: 120px;
                height: 100%;
                border-radius: 4px;
                line-height: 40px;
                text-align: center;
                font-size: 14px;
                cursor: pointer;
                &:hover{
                    opacity: 0.8;
                }
                &:first-child{
                    background: #DCE0E0;
                    color: #555555;
                }
                &:last-child{
                    background: #308697;
                    color: #FFFFFF;
                    margin-left: 20px;
                }
            }
        }
    }
</style>
<style scoped>
    .contact-cont p.text{
        font-size: 12px;
        color:#308697;
        text-align:center;
    }
</style>